import { get } from '../../../../util/api'
import * as type from './type'

export const fetchBasisReportRequest = () => ({
    type: type.FETCH_BASIS_REPORT_REQUEST,
})

export const fetchBasisReportSuccess = (monthList) => ({
    type: type.FETCH_BASIS_REPORT_SUCCESS,
    payload: {
        monthList,
    },
})

export const fetchBasisReportError = (error) => ({
    type: type.FETCH_BASIS_REPORT_ERROR,
    payload: {
        error,
    },
})


export const fetchBasisReport = () => (dispatch, getState) => {
    dispatch(fetchBasisReportRequest())
    get('/api/sales-order/reporting/y2d-basis')
        .then(monthList => {
            dispatch(fetchBasisReportSuccess(monthList))
        })
        .catch(error => {
            dispatch(fetchBasisReportError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/analytics/state/basis/action.js